import { ActionPlanDetailsType } from 'types/actionPlans';
import { UserActorType } from 'types/user';

import { ACTION_PLAN_ITEM_TYPE_OPTIONS } from './constants';
import { OwnerOption, SelectOption } from './CreateEditActionPlansModalTypes';
import { getUserDisplayName, toNumberOrUndefined } from './utils';

const getUserRole = (user: UserActorType) =>
  user.position_rights?.trim() || user.position?.name?.trim() || user.role?.trim() || user.title?.trim();

export const buildOwnerOptions = (
  users: UserActorType[] | undefined,
  details?: ActionPlanDetailsType | null
): OwnerOption[] => {
  const usersOwnerOptions: OwnerOption[] = [];

  (users ?? []).forEach((user) => {
    const value = toNumberOrUndefined(user.auth_user_id ?? user.id);
    if (value) {
      usersOwnerOptions.push({
        label: getUserDisplayName(user),
        value,
        email: user.email,
        role: getUserRole(user),
      });
    }
  });

  const detailsOwnerOptions: OwnerOption[] = [];

  if (details?.owner) {
    const value = toNumberOrUndefined(details.owner.id);
    if (value) {
      detailsOwnerOptions.push({ label: details.owner.name, value, role: details.owner.position_rights ?? undefined });
    }
  }

  (details?.steps ?? []).forEach((step) => {
    if (!step.owner) {
      return;
    }

    const value = toNumberOrUndefined(step.owner.id);
    if (value) {
      detailsOwnerOptions.push({ label: step.owner.name, value, role: step.owner.position_rights ?? undefined });
    }
  });

  const ownerMap = new Map<number, OwnerOption>();
  [...usersOwnerOptions, ...detailsOwnerOptions].forEach((item) => {
    ownerMap.set(item.value, item);
  });

  return Array.from(ownerMap.values());
};

export const buildItemTypeOptions = (details?: ActionPlanDetailsType | null): SelectOption[] => {
  const baseOptions = ACTION_PLAN_ITEM_TYPE_OPTIONS.map((item) => ({ label: item.name, value: item.id }));
  const existingIds = new Set(baseOptions.map((option) => option.value));

  (details?.steps ?? []).forEach((step) => {
    const typeId = toNumberOrUndefined(step.type_id);
    const typeName = step.type_name?.trim();
    if (typeId && typeName && !existingIds.has(typeId)) {
      baseOptions.push({ label: typeName, value: typeId });
      existingIds.add(typeId);
    }
  });

  return baseOptions;
};
